<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >资产审批</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入资产名称或流程ID"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column
                            align="center"
                            title="审批"
                            width="100"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    status="success"
                                    icon="fa fa-check"
                                    round
                                    @click="auditRowEvent(row)"
                                    >审批</vxe-button
                                >
                            </template>
                        </vxe-column>
                        <vxe-column align="center" title="状态" width="100">
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.AssetStatus }}</vxe-button
                                >
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="Name"
                            title="资产名称"
                            show-overflow
                            width="220"
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="buSystem"
                            title="业务系统"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Description"
                            title="资产描述"
                            width="200"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="ValueType"
                            title="资产类型"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ValueName"
                            title="资产值"
                            width="200"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="流程ID"
                            width="140"
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="RobotName"
                            title="机器"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="AssetSet"
                            title="资产集"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="CreatorUser"
                            title="创建人"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="创建时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="requestreason"
                            title="申请原因"
                            width="140"
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <vxe-modal
                v-model="formInput.isShow"
                @close="closeWinEvent"
                :title="formInput.title"
                width="800"
                height="540"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="rForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="流程ID"
                            field="ProcessName"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.ProcessName"
                                    placeholder="请输入流程ID"
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    :disabled="formInput.allInputDisable"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="业务系统"
                            field="BuSystem"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.BuSystem"
                                    :options="toolbar.BuSysOptions"
                                    placeholder="请选择业务系统"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="资产类型"
                            field="ValueType"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.ValueType"
                                    placeholder="请选择资产类型"
                                    :disabled="formInput.allInputDisable"
                                    clearable
                                    @change="valueChange"
                                >
                                    <vxe-option
                                        value="5"
                                        label="凭据"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="文本"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="密码到期提醒"
                            field="expireDate"
                            span="12"
                            title-width="120px"
                            :title-prefix="{
                                icon: 'fa fa-info-circle',
                                message:
                                    '如对应业务系统密码需定期修改，维护该日期，系统将会提前3天推送邮件提醒您更新密码',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    type="date"
                                    v-model="formInput.formData.expireDate"
                                    placeholder="请选择密码到期提醒"
                                    clearable
                                    transfer
                                    :disabled="formInput.allInputDisable"
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="系统账号"
                            field="Username"
                            span="12"
                            title-width="100px"
                            :visible-method="isShowUserName"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.Username"
                                    placeholder="请输入系统账号"
                                    :disabled="
                                        !formInput.assetType ||
                                        formInput.allInputDisable
                                    "
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="系统密码"
                            field="Password"
                            span="12"
                            title-width="100px"
                            :visible-method="isShowUserName"
                        >
                            <template #default>
                                <vxe-input
                                    type="password"
                                    v-model="formInput.formData.Password"
                                    placeholder="请输入系统密码"
                                    clearable
                                    :disabled="
                                        !formInput.assetType ||
                                        formInput.allInputDisable
                                    "
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="文本"
                            field="Text"
                            span="24"
                            title-width="100px"
                            :visible-method="isShowText"
                        >
                            <template #default>
                                <vxe-input
                                    :disabled="
                                        formInput.assetType ||
                                        formInput.allInputDisable
                                    "
                                    v-model="formInput.formData.Text"
                                    placeholder="请输入文本"
                                    clearable
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="资产描述"
                            field="Description"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    type="text"
                                    v-model="formInput.formData.Description"
                                    placeholder="请输入资产描述"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="统一认证登录"
                            field="IsUniAuth"
                            span="12"
                            title-width="130px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.IsUniAuth"
                                    placeholder="请选择是否统一认证登录"
                                    clearable
                                >
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="申请原因"
                            field="RequestReason"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.RequestReason"
                                    placeholder="请输入申请原因"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item span="24">
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="auditOpinion"
                                    placeholder="请输入审核意见"
                                    maxlength="1000"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            align="center"
                            span="24"
                            style="position: absolute; bottom: 0"
                        >
                            <template #default>
                                <vxe-button
                                    @click="reject"
                                    icon="fa fa-reply"
                                    status="danger"
                                    >驳回
                                </vxe-button>
                                <vxe-button
                                    @click="submit"
                                    icon="fa fa-check"
                                    status="success"
                                    >通过
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VXETable } from "vxe-table";
import MyAuditLine from "../myPlug/MyAuditLine";

export default {
    name: "AssetAudit",
    components: { MyAuditLine },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });

        const toolbar = reactive({
            loading: false,
            macOptions: [],
            statusOptions: [],
            BuSysOptions: [],
            formData: {
                selectMac: "",
                searchKey: "",
                status: "",
            },
        });
        const formInput = reactive({
            title: "审核资产",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            assetType: true,
            formData: {
                Id: "",
                OCAssetId: "0",
                Name: "",
                ProcessName: "",
                BuSystem: "",
                TenantId: "",
                CanBeDeleted: "1",
                ValueScope: "",
                ValueType: "5",
                IsDeleted: "0",
                OrganizationUnitId: "3",
                Description: "",
                AssetSet: "1",
                AssetStatus: "1",
                IsEnable: "1",
                RejectReason: "",
                RequestReason: "",
                expireDate: "",
                Username: "",
                Password: "",
                Creator: "",
                Text: "",
                IsUniAuth: "",
            },
            formRules: {
                ProcessName: [{ required: false, message: "流程ID不能为空" }],
                BuSystem: [{ required: false, message: "业务系统不能为空" }],
                Username: [{ required: false, message: "系统账号不能为空" }],
                Password: [{ required: false, message: "系统密码不能为空" }],
                ValueType: [{ required: false, message: "资产类型不能为空" }],
                expireDate: [
                    { required: false, message: "密码到期提醒不能为空" },
                ],
                Description: [{ required: false, message: "资产描述不能为空" }],
                RequestReason: [
                    { required: true, message: "申请原因不能为空" },
                ],
                Text: [{ required: false, message: "文本不能为空" }],
                IsUniAuth: [
                    { required: true, message: "统一验证登录不能为空" },
                ],
            },
        });

        const auditOpinion = ref("OK");
        return {
            tableData: null,
            tablePager,
            toolbar,
            formInput,
            pageHeight,
            dtAudit: [],
            isShowAuditList: false,
            auditOpinion,
            tableHeight: 0,
        };
    },
    methods: {
        isShowUserName() {
            return this.formInput.assetType;
        },
        isShowText() {
            return !this.formInput.assetType;
        },
        auditRowEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };

            this.$api.assetManageAPI
                .getOneAsset(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    this.formInput.formData = res.data.Data;
                    this.auditOpinion = "OK";
                    //显示附件下载
                    this.formInput.title = "审核资产申请";
                    if (this.formInput.formData.ValueType === 5) {
                        this.formInput.formData.ValueType = "5";
                        this.formInput.assetType = true;
                    } else {
                        this.formInput.formData.ValueType = "2";
                        this.formInput.assetType = false;
                    }

                    this.formInput.allInputDisable = true;
                    this.formInput.saveButDisable = true;

                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [this.toolbar.formData.searchKey],
            };
            this.$api.assetManageAPI
                .getAssetAudit(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        addAuditRecord(status) {
            //写审核日志
            const params = {
                auditBuId: this.formInput.formData.Id,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: this.auditOpinion,
                auditNode: "",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //驳回
        async reject() {
            if (this.auditOpinion === "OK") {
                VXETable.modal.message({
                    content: "驳回请修改默认审核意见",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要驳回吗?");

            if (type === "confirm") {
                this.$api.assetManageAPI
                    .auditAsset(
                        Qs.stringify({
                            assetId: this.formInput.formData.Id,
                            editType: "1",
                            userId: this.$store.state.userID,
                        })
                    )
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        this.findData();
                        //审核记录
                        this.addAuditRecord("2"); //2 驳回

                        VXETable.modal.message({
                            content: "驳回成功",
                            status: "success",
                        });
                        this.formInput.isShow = false;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //提交
        async submit() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            if (this.auditOpinion === "") {
                VXETable.modal.message({
                    content: "审核意见不能为空",
                    status: "error",
                });
                return;
            }
            const param = {
                assetId: this.formInput.formData.Id,
                editType: "2",
                userId: this.$store.state.userID,
                IsUniAuth: this.formInput.formData.IsUniAuth,
            };

            this.$api.assetManageAPI
                .auditAsset(Qs.stringify(param))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "审批成功",
                        status: "success",
                    });
                    this.findData();
                    this.addAuditRecord("1"); //1 通过
                    this.formInput.isShow = false;
                })
                .catch((error) => {
                    VXETable.modal.message({ content: error, status: "error" });
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        closeWinEvent() {
            this.findData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
